import Ajv from 'ajv'

import Configuration from '../Configuration.js'

export default (store) => {
    const validator = new Ajv({
        unknownFormats: Configuration.get('validation.unknownFormats', []),
        coerceTypes: true,
        nullable: true
    })

    for (const schema in store.state.schema) {
        validator.addSchema(store.state.schema[schema], schema)
    }

    store.subscribeAction({
        before: (action, state) => {
            if (action.type !== 'patch') {
                return
            }

            const schema = state.definition[action.payload.scope.type]

            validator.validate(schema, action.payload.scope)
        }
    })
}